if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification'); // Removed dawn13-cart-drawer reference
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const forceCartPage = document.body.classList.contains('no-drawer');    

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      let disclaimerCheck = document.querySelector('#custom-disclaimer');
      if (disclaimerCheck?.required && !disclaimerCheck.checked) {
        this.handleErrorMessage("Please read and confirm details below");
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.main-atc-spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // No cart drawer or redirect
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;

          updateCartCountBubble();
          document.body.classList.remove('overflow-hidden');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.main-atc-spinner')?.classList.add('hidden');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        this.errorMessage.scrollIntoView({ block: 'center' });
      }
    }
  });
}

function updateCartCountBubble() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const bubble = document.querySelector('#dawn13-cart-icon-bubble .cart-count-bubble');
      if (!bubble) return;

      bubble.textContent = count > 0 ? count : '';
      bubble.classList.toggle('hidden', count === 0);
    })
    .catch(err => console.warn('[Cart Count] Failed to update:', err));
}

